import { ConcreteEncodable } from "./ConcreteEncodable";

import { EnumTupleImplEncoder } from "../../encoder/EnumTupleImplEncoder";

import * as CubiqTS from "../../index";
import { EnumTuple } from "../EnumTuple";

export class EnumTupleImpl extends ConcreteEncodable implements EnumTuple {
  public static enType: string = "com.bcdfx.model.event.admin.EnumTupleImpl";

  /*FID=1*/
  public ordinal: number;
  /*FID=2*/
  public enumValue: number;
  /*FID=3*/
  public enumName: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = EnumTupleImplEncoder.Instance;
    this.setEncodableType(EnumTupleImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "EnumTupleImpl[" +
      "ordinal=" +
      this.ordinal +
      "enumValue=" +
      this.enumValue +
      "enumName=" +
      this.enumName +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
